var init = false;
var swiper;
function swiperCard() {
  if (window.innerWidth <= 575) {
    if (!init) {
      init = true;
      swiper = new Swiper(".blog_slider.swiper", {
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    }
  } else if (init) {
    swiper.destroy();
    init = false;
  }
}
swiperCard();
window.addEventListener("resize", swiperCard);
